import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SwitchingDialogService } from '../../services/dialog-type.service';
import { ACTION } from '@configs/constants/action.constant';
import { EigBaseAdminComponent } from '../eig-base/eig-base-admin.component';
import { SessionService } from '@core/services/session.service';
import { AdminModule } from '@modules/auth/models/user-auth.model';

@Component({
    selector: 'app-modal-dialog-container',
    templateUrl: './modal-dialog-container.component.html',
    styleUrls: ['./modal-dialog-container.component.scss']
})
export class ModalDialogContainerComponent extends EigBaseAdminComponent implements OnInit {

    @Input()
    title: string;

    @Input()
    isEdit = false;

    // Whether a screen has edit function or not
    @Input()
    isSupportEdit = true;

    @Input()
    canDelete = false;

    @Input()
    isSaveButton = true;

    @Input()
    saveText: string;

    @Input()
    saveAndThenText: string;

    @Input()
    saveThenOtherText: string;
    @Input()
    saveThenOtherIcon: string;

    @Input()
    isSaveAndAddOneMore = false;

    @Input()
    adminModule: AdminModule;

    // The data of record
    @Input()
    data: any;

    @Input()
    dirty = false;

    @Input()
    isManualDeposit = false;

    @Output()
    save: EventEmitter<any>;
    @Output()
    saveAndAddOneMore: EventEmitter<any>;

    @Output()
    saveAndThen: EventEmitter<any>;
    @Output()
    saveAndThenOther: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    delete: EventEmitter<any>;

    constructor(
        protected sessionService: SessionService,
        private translateService: TranslateService,
        private switchingDialogService: SwitchingDialogService,
    ) {
        super(sessionService);

        this.save = new EventEmitter<any>();
        this.saveAndAddOneMore = new EventEmitter<any>();
        this.saveAndThen = new EventEmitter<any>();
        this.delete = new EventEmitter<any>();
        this.saveAndThenText = this.translateService.instant('button_name.save_then_return');
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    onSave(): void {
        this.save.next();
    }
    onSaveAndAddOneMore(): void {
        this.saveAndAddOneMore.next();
    }

    onSaveThen(): void {
        this.saveAndThen.next();
    }

    onSaveThenOther(): void {
        this.saveAndThenOther.next();
    }

    onDelete(): void {
        this.delete.next();
    }

    onSwitchToEditPage() {
        this.switchingDialogService.onToggleDialogType({dialogType: ACTION.EDIT, recordData: this.data});
    }

}
